import { render, staticRenderFns } from "./TimeFrame.vue?vue&type=template&id=0fb1c28a&scoped=true&"
import script from "./TimeFrame.vue?vue&type=script&lang=js&"
export * from "./TimeFrame.vue?vue&type=script&lang=js&"
import style0 from "./TimeFrame.vue?vue&type=style&index=0&id=0fb1c28a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1c28a",
  null
  
)

export default component.exports